import React from 'react';
import { Container, Grid, Typography, Box, Toolbar } from '@mui/material';
import smartphoneImage from '../assets/smartphone-preview.png';
import Header from '../components/Header';

export default function HomePage() {
  return (
    <>
      <Header />
      <Toolbar />
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Grid container spacing={5} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box display="flex" justifyContent="center">
              <img src={smartphoneImage} alt="スマートフォン" style={{ maxWidth: '50%', height: 'auto' }} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" component="h1" gutterBottom>
              食材関連発注システム
            </Typography>
            <Box
              sx={{
              bgcolor: '#3f51b5',
              color: '#fff',
              fontSize: '1.5rem',
              padding: '10px 20px',
              borderRadius: '20px',
              textAlign: 'center',
              display: 'inline-block',
              }}
            >
              フードコミュニティ
            </Box>
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
              飲食店からの発注を快適且つスムーズにする
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
